import {
    FETCH_HRV_STATUS_DAILY_SUMMARY_START,
    FETCH_HRV_STATUS_DAILY_SUMMARY_SUCCESS,
    FETCH_HRV_STATUS_DAILY_SUMMARY_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    dailySummary: {
        data: null,
        success: false,
        error: false,
        fetching: false
    },
    daily: {
        data: null,
        success: false,
        error: false,
        fetching: false
    }
};

const hrvStatusDailySummaryFetching = (state, action) => {
    return {
        ...state,
        dailySummary: {
            ...state.dailySummary,
            data: null,
            fetching: true
        }
    };
};

const hrvStatusDailySummarySuccess = (success) => (state, action) => {
    return {
        ...state,
        dailySummary: {
            ...state.dailySummary,
            data: success ? action.data : null,
            success: success,
            error: !success,
            fetching: false
        }
    };
};

export const isHRVStatusDailySummaryFetching = (state) => {
    return state.hrvStatus.dailySummary.fetching;
};

export const getHRVStatusDailySummary = (state) => {
    return state.hrvStatus.dailySummary.data;
};

export const isHRVStatusDailySummarySuccess = (state) => {
    return state.hrvStatus.dailySummary.success;
};

export const isHRVStatusDailySummaryError = (state) => {
    return state.hrvStatus.dailySummary.error;
};

const handlers = {
    [FETCH_HRV_STATUS_DAILY_SUMMARY_SUCCESS]: hrvStatusDailySummarySuccess(true),
    [FETCH_HRV_STATUS_DAILY_SUMMARY_START]: hrvStatusDailySummaryFetching,
    [FETCH_HRV_STATUS_DAILY_SUMMARY_FAIL]: hrvStatusDailySummarySuccess(false)
};

export default function hrvStatus(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
